import './polyfill.tsx';

import { createRoot } from 'react-dom/client';

import Root from './root.tsx';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Root />);
